import { SidePanelContainer } from 'components/staticForm/sidePanelLayout/SidePanelContainer';
import { FC } from 'react';

import { SidePanel } from './components/SidePanel/SidePanel';
import { TradeAllocationMainForm } from './TradeAllocationMainForm';

interface TradeAllocationFormProps {
  tabId: string;
}

export const TradeAllocationForm: FC<TradeAllocationFormProps> = ({ tabId }) => {
  return (
    <SidePanelContainer sidePanel={<SidePanel tabId={tabId} />} topBar={null}>
      <TradeAllocationMainForm tabId={tabId} />
    </SidePanelContainer>
  );
};

TradeAllocationForm.displayName = 'TradeAllocationForm';
